/**
 * FireworkArtwork
 * Author: Wataru Fukushima
 * License: CC BY-ND 4.0
 */

import { FireworkStar } from './index'

export default class Firework {
  artwork = null
  star = null

  constructor({ artwork }) {
    this.artwork = artwork
    this.artwork.eventBus.$on('onRender', this.render.bind(this))
  }

  init() {
    //* 花火玉を作成
    this.star = new FireworkStar({ artwork: this.artwork })
    this.artwork.scene.add(this.star.mesh)
  }

  render() {}
}
